import { render } from "./TheAside.vue?vue&type=template&id=c4a13b68&scoped=true"
import script from "./TheAside.vue?vue&type=script&lang=js"
export * from "./TheAside.vue?vue&type=script&lang=js"

import "./TheAside.vue?vue&type=style&index=0&id=c4a13b68&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4a13b68"]])

export default __exports__